// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"mainContainer--Kgll9","blocked":"blocked--GjTXV"};